import { makeStyles } from "@fluentui/react-components";
import { themeTokens } from "Core/Theme";

export const useUniversalSearchFiltersStyles = makeStyles({
    tagGroup: {
        display: "flex",
        flexWrap: "wrap",
        gap: themeTokens.spacingVerticalS,
        justifyContent: "flex-start"
    }
});
